export type AuthType =
  | 'emailLinkOnly'
  | 'phoneOtpOnly'
  | 'emailOtpOnly'
  | 'emailLinkPhoneOtp'
  | 'emailOtpPhoneOtp';

/** Legacy SCREAMING_SNAKE_CASE values that may still arrive from old API records */
type LegacyAuthTypeValue =
  | 'EMAIL_OTP_SMS_OTP'
  | 'EMAIL_LINK_ONLY'
  | 'PHONE_OTP_ONLY'
  | 'EMAIL_OTP_ONLY'
  | 'EMAIL_LINK_SMS_OTP'
  | 'EMAIL_OTP_TEXT_OTP'
  | 'EMAIL_LINK_TEXT_OTP';

export type OnboardingOptionDefinition = {
  value: AuthType;
  title: string;
  helperText: string;
  requiresValidPhone: boolean;
};

const LEGACY_OPTION_TO_CURRENT: Record<LegacyAuthTypeValue, AuthType> = {
  EMAIL_OTP_SMS_OTP:  'emailOtpPhoneOtp',
  EMAIL_OTP_TEXT_OTP: 'emailOtpPhoneOtp',
  EMAIL_LINK_ONLY:    'emailLinkOnly',
  PHONE_OTP_ONLY:     'phoneOtpOnly',
  EMAIL_OTP_ONLY:     'emailOtpOnly',
  EMAIL_LINK_SMS_OTP: 'emailLinkPhoneOtp',
  EMAIL_LINK_TEXT_OTP:'emailLinkPhoneOtp',
};

export const DEFAULT_ONBOARDING_OPTION: AuthType = 'emailLinkOnly';

export const FIRM_CONFIG_LABELS: Record<string, string> = {
  email: 'Email',
  sms: 'SMS',
  both: 'Email & SMS',
};

export const getFirmConfigLabel = (firmConfigValue?: string | null): string => {
  if (!firmConfigValue) return '—';
  return FIRM_CONFIG_LABELS[firmConfigValue] ?? firmConfigValue;
};

export const ONBOARDING_OPTION_DEFINITIONS: OnboardingOptionDefinition[] = [
  {
    value: 'emailOtpOnly',
    title: 'Email OTP Only',
    helperText: 'User receives Email OTP only',
    requiresValidPhone: false,
  },
  {
    value: 'emailLinkOnly',
    title: 'Email Link Only',
    helperText: 'User receives an Email link only',
    requiresValidPhone: false,
  },  
  // {
  //   value: 'phoneOtpOnly',
  //   title: 'Phone OTP Only',
  //   helperText: 'User receives Text OTP only',
  //   requiresValidPhone: true,
  // },
  // {
  //   value: 'emailLinkPhoneOtp',
  //   title: 'Email Link + Phone OTP',
  //   helperText: 'User receives an Email link and Text OTP',
  //   requiresValidPhone: true,
  // },
  // {
  //   value: 'emailOtpPhoneOtp',
  //   title: 'Email OTP + Phone OTP',
  //   helperText: 'User receives OTP via Email and Text',
  //   requiresValidPhone: true,
  // },
];

export const getUserSelectedLabels = (option: AuthType): string[] => {
  const def = ONBOARDING_OPTION_DEFINITIONS.find((d) => d.value === option);
  return def ? [def.title] : [];
};

export const isAuthType = (value?: string | null): value is AuthType =>
  !!value && ONBOARDING_OPTION_DEFINITIONS.some((d) => d.value === value);

export const normalizeOnboardingOptionValue = (value?: string | null): AuthType => {
  if (!value) return DEFAULT_ONBOARDING_OPTION;

  if (isAuthType(value)) return value;

  if (value in LEGACY_OPTION_TO_CURRENT) {
    return LEGACY_OPTION_TO_CURRENT[value as LegacyAuthTypeValue];
  }

  return DEFAULT_ONBOARDING_OPTION;
};
